import { FOCUS_RING } from './focusRing.ts'

/**
 * The persistent branded header, ported from V1.
 *
 * A product lockup rather than a title: the mark (a flask in a brand-blue
 * square) beside a two-line name. V1 arrived here after review feedback that a
 * bare title "looked like a module built in a hurry", and the whole lockup is
 * a button back to the queue.
 *
 * No full-bleed bar. The background is inherited from `<body>`, which is the
 * sunken tone, and the header sits inside the same 1440px column as the
 * content so the mark's left edge lines up with the table's.
 *
 * V1's retired "RUN / PHARMA" logotype stays retired -- `quave-logo.svg` and
 * `quave-symbol.svg` are in `public/` for whoever wants the mark elsewhere.
 */
export function TopBar({ onHome, children }: { onHome: () => void; children?: React.ReactNode }) {
  return (
    <header className="flex items-center justify-between pt-7" aria-label="Top bar">
      {/* Chrome, not the page heading -- the content owns <h1>. */}
      <button
        type="button"
        onClick={onHome}
        className={`rounded-base flex items-center gap-2 text-left no-underline ${FOCUS_RING}`}
      >
        {/* The Quave badge, served from public/ like the other marks. */}
        <img src="/badge-indigo.svg" alt="" aria-hidden="true" className="h-9 w-9 shrink-0" />
        <span className="flex flex-col gap-px">
          <h5 className="text-tH5 text-text-strong whitespace-nowrap">Quave Magistral</h5>
          <span className="text-tTiny text-text-weak whitespace-nowrap tracking-widest uppercase">
            Conferência de receitas
          </span>
        </span>
      </button>
      <div className="flex min-w-0 flex-1 items-center justify-end gap-3 pl-6">{children}</div>
    </header>
  )
}
